export default function initNovidadesRelacionadas() {
    const swiperContainer = document.querySelector('.c-related-news__swiper');

    if (!swiperContainer) return;

    const relatedNewsSwiper = new Swiper(swiperContainer, {

        slidesPerView: 1.1,
        spaceBetween: 15,
        grabCursor: true,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        watchOverflow: true,

         autoplay: {
            delay: 5000, 
            disableOnInteraction: false, 
            pauseOnMouseEnter: true, 
        },
        
        a11y: {
            enabled: true,
            prevSlideMessage: 'Slide anterior',
            nextSlideMessage: 'Próximo slide',
            firstSlideMessage: 'Este é o primeiro slide',
            lastSlideMessage: 'Este é o último slide',
            paginationBulletMessage: 'Ir para o slide {{index}}',
        },

        navigation: {
            nextEl: '.c-related-news__arrow--next.js-related-next',
            prevEl: '.c-related-news__arrow--prev.js-related-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },

        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 20,
                slidesOffsetBefore: 50,
                slidesOffsetAfter: 50,
            }
        }
    });

    return relatedNewsSwiper;
}